import { React, useEffect } from 'react';
import { ArrowRightOnRectangleIcon, UserCircleIcon } from '@heroicons/react/24/solid';

import { NavLink, useNavigate } from 'react-router-dom';
import { AppStateProvider, useAppState } from '../../AppStateContext';

const Sidebar = () => {
    
  const { user, updateUser } = useAppState();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     updateUser(JSON.parse(storedUser));
  //   }
  //   // setLoading(false);
  // }, [updateUser]);

  const menuItems = [
    { name: 'Lapangan', icon: '/ic-field-solid.svg', link: '/' },
    // { name: 'Dashboard', icon: '/ic-task.svg', link: '/' },
    { name: 'Add On', icon: '/ic-addon-solid.svg', link: '/addon' },
    { name: 'Daftar Transaksi', icon: '/ic-transaction-solid.svg', link: '/transaction' },
    // { name: 'Lapangan', icon: '/ic-field-solid.svg', link: '/venue/list' },
    // { name: 'Company', icon: '/ic-field-solid.svg', link: '/company' },
    { name: 'Settlement', icon: '/ic-withdraw.svg', link: '/settlement' },
    { name: 'Pengaturan', icon: '/ic-cog-solid.svg', link: '/pengaturan' },
  ];

  const handleSignOut = () => {
      updateUser(null);
      navigate('/login');
  };

  return (
    <div className='w-full h-fit flex flex-col'>

      <dif className="pt-[33px] pl-[46px] mr-[24px]">
        <img src='/logo_fityuk.webp' className='w-full h-auto' />

      </dif>

      <div style={{ backgroundColor: '#fff5f5' }} className="rounded-md mt-[24px] ml-6 sm:mr-4 p-[14px] mb-6 lg:mr-0">

          {menuItems.map((item) => (
              <NavLink
                to={item.link}
                className={({ isActive }) => `flex items-center font-bold py-2 px-2 rounded-md p-2 ${isActive ? 'bg-red-500 text-white' : 'text-gray-400'} hover:bg-red-500 hover:text-white`}
              >
                <img src={item.icon} alt={item.name} className="h-8 w-8 mr-2" />
                <p className='text-sm'>{item.name}</p>
              </NavLink>
          ))}

        <div className='flex items-center mt-24 hover:bg-primaryRed p-2 text-gray-800 hover:text-white hover:font-semibold rounded-md' >
          <UserCircleIcon className='w-8 text-gray-400' />
          <div className='flex-1 flex-col' >
            <p className='mx-2 font-semibold text-xs'>Halo,</p>
            <p className='mx-2 font-bold text-xs'>{user.name}</p>
          </div>
          <img src='/ic-signout.svg' className='w-7 text-gray-400' onClick={handleSignOut}/>
        </div>
      </div>
    </div >
  );
}

export default Sidebar;